import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSpinnerComponent } from '@nx-customer-apps/components';

@Component({
    imports: [RouterOutlet, GlobalSpinnerComponent],
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
    public translateService = inject(TranslateService);

    ngOnInit(): void {
        this.translateService.use('en-DE');
    }
}
